import { useNavigate } from 'react-router-dom';
import { VscGame } from 'react-icons/vsc';
import avatar1 from './images/img1.png';
import avatar2 from './images/img2.png';
import avatar3 from './images/img3.png';
import { ChallengeCard, ChallengeCardBody, ChallengeCardHat, ChallengeCardTitle } from '@/components/custom/challenge';
import { Button, ButtonIcon } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';

export function WeekChallengeCardDuel() {
  const navigate = useNavigate();

  return (
    <ChallengeCard variant="turbo">
      <ChallengeCardHat>Novidade</ChallengeCardHat>

      <div className="relative my-8 flex items-end justify-center -space-x-6">
        <AvatarWrapper
          src={avatar1}
          className="size-14"
        />
        <AvatarWrapper
          src={avatar2}
          className="size-20"
        />
        <AvatarWrapper
          src={avatar3}
          className="size-14"
        />
      </div>

      <ChallengeCardBody className="justify-start">
        <ChallengeCardTitle
          className="mb-2 text-center text-lg font-extrabold"
          style={{ '--color-primary-dark': '#0B4360' }}
        >
          Desafie seus colegas
        </ChallengeCardTitle>
        <p className="my-3 text-center text-xs font-bold text-neutral-dark">Participe de duelos e teste seus conhecimentos</p>
      </ChallengeCardBody>

      <Button
        variant="merit"
        size="sm"
        border
        onClick={() => navigate('/duelos')}
      >
        <ButtonIcon>
          <VscGame />
        </ButtonIcon>
        Iniciar Duelos
      </Button>
    </ChallengeCard>
  );
}
